import {useApolloClient, useMutation} from '@apollo/client'
import {useCallback} from 'react'

import {
  getNotificationCountRedis,
  updateNotificationCountRedis,
} from '../queries/notificationQuery'
import {checkObjProps, logError} from '../utils/genericUtils'

// No useQuery — safe to call per row; badge consumers use useNotificationCount.
export const useAcknowledgeOneNotification = (): (() => Promise<void>) => {
  const client = useApolloClient()
  const [updateRedis] = useMutation(updateNotificationCountRedis)

  return useCallback(async () => {
    try {
      // network-only so two rapid clicks don't both read the same cached value and lose a decrement.
      const res = await client.query({
        query: getNotificationCountRedis,
        fetchPolicy: 'network-only',
      })
      const currentRedis: number = checkObjProps(
        res.data,
        ['getNotificationCount', 'notificationCount'],
        0
      )
      await updateRedis({
        variables: {data: Math.max(0, currentRedis - 1)},
        refetchQueries: [{query: getNotificationCountRedis}],
      })
    } catch (err) {
      logError('Error decrementing notification count:', err)
    }
  }, [client, updateRedis])
}
